import CustomTooltip from "../../../../common/styles/components/tooltip/CustomTooltip";
import TooltipRenderer from "../../../../components/TooltipRenderer";
import IconButton from "../../../../packages/IconButton";
import {
  CaretRight,
  CaretDown,
  ExcelIcon,
  FileIcon,
  ReplaceIcon,
  RemoveIcon,
} from "../../../../assets/icons";

const UploadedFilesList = ({
  uploadedFileCards,
  isReplaceDeleteDisabled,
  isActionLoading,
  expandedCardsById,
  onToggleCard,
  onReplaceFile,
  onDeleteFile,
  t,
}) => {
  return (
    <>
      {!!uploadedFileCards.length &&
        uploadedFileCards.map((uploadedCard, cardIndex) => {
          const cardSheets = Array.isArray(uploadedCard.sheets)
            ? uploadedCard.sheets
            : [];
          const isCsvFile = uploadedCard?.fileName
            ?.toLowerCase()
            .endsWith(".csv");
          const isCardExpanded = expandedCardsById[uploadedCard.id] === true;
          const hasValidPlantFileId =
            uploadedCard?.id || uploadedCard?.id === 0;
          const isReplaceActionDisabled =
            isReplaceDeleteDisabled || !hasValidPlantFileId;
          const isDeleteActionDisabled =
            isReplaceDeleteDisabled || !hasValidPlantFileId;
          const replaceTooltip = isReplaceDeleteDisabled
            ? t("fileUpload.replaceDisabledNotOwner")
            : t("fileUpload.replace");
          const deleteTooltip = isReplaceDeleteDisabled
            ? t("fileUpload.deleteDisabledNotOwner")
            : t("ValueStrings.delete");
          const resolvedReplaceTooltip = isActionLoading ? "" : replaceTooltip;
          const resolvedDeleteTooltip = isActionLoading ? "" : deleteTooltip;

          return (
            <div className="upload-success-card" key={uploadedCard.id}>
              <div className="upload-success-card__header">
                <div className="upload-success-card__main">
                  <IconButton
                    id={`uploaded-card-toggle-${cardIndex}`}
                    className="upload-success-card__expand-toggle"
                    onClick={() => onToggleCard(uploadedCard.id)}
                  >
                    {isCardExpanded ? <CaretDown /> : <CaretRight />}
                  </IconButton>
                  {isCsvFile ? (
                    <FileIcon className="upload-success-card__file-icon upload-success-card__file-icon--csv" />
                  ) : (
                    <ExcelIcon className="upload-success-card__file-icon" />
                  )}
                  <TooltipRenderer title={uploadedCard.fileName}>
                    <p className="upload-success-card__file-name">
                      {uploadedCard.fileName}
                    </p>
                  </TooltipRenderer>
                </div>

                <div className="upload-success-card__meta">
                  <span className="upload-success-card__sheet-count">
                    {cardSheets.length}
                  </span>
                  <span className="upload-success-card__sheet-label">
                    {t("analyseData.sheets")}
                  </span>
                </div>

                <div className="upload-success-card__actions">
                  <IconButton
                    id={`replace-uploaded-file-${cardIndex}`}
                    className="upload-success-card__action upload-success-card__action--replace"
                    onClick={() => onReplaceFile?.(uploadedCard)}
                    tooltip={resolvedReplaceTooltip}
                    disabled={isReplaceActionDisabled}
                    isDisabledTooltip
                  >
                    <ReplaceIcon />
                  </IconButton>

                  <IconButton
                    id={`remove-uploaded-file-${cardIndex}`}
                    className="upload-success-card__action upload-success-card__action--remove"
                    onClick={() => onDeleteFile?.(uploadedCard)}
                    tooltip={resolvedDeleteTooltip}
                    disabled={isDeleteActionDisabled}
                    isDisabledTooltip
                  >
                    <RemoveIcon />
                  </IconButton>
                </div>
              </div>

              {isCardExpanded && !!cardSheets.length && (
                <div className="upload-success-card__sheet-list">
                  {cardSheets.map((sheet, sheetIndex) => {
                    const sheetName = sheet?.sheetName;
                    const displaySheetName = isCsvFile
                      ? uploadedCard.fileName
                      : sheetName;
                    const sheetKey = `${displaySheetName}-${sheetIndex}`;
                    const normalizedTrainNums = Array.isArray(sheet?.trainNums)
                      ? sheet.trainNums
                      : [];
                    const uniqueTrainNums = [...new Set(normalizedTrainNums)]
                      .filter((trainNum) => trainNum || trainNum === 0)
                      .sort((a, b) => Number(a) - Number(b));
                    const additionalTrainCount = Math.max(
                      0,
                      uniqueTrainNums.length - 1,
                    );
                    const mappedTrainBaseLabel = uniqueTrainNums.length
                      ? `${t("ValueStrings.train")} ${uniqueTrainNums[0]}`
                      : "";
                    const mappedTrainExtraLabel =
                      additionalTrainCount > 0
                        ? `(+${additionalTrainCount})`
                        : "";
                    const mappedTrainTooltip = uniqueTrainNums
                      .map(
                        (trainNum) => `${t("ValueStrings.train")} ${trainNum}`,
                      )
                      .join(", ");
                    const showTrainTooltip = additionalTrainCount > 0;

                    return (
                      <div
                        key={`${uploadedCard.id}-${sheetKey}`}
                        className="upload-success-card__sheet-row"
                      >
                        <div className="upload-success-card__sheet-separator" />
                        <span
                          className="upload-success-card__sheet-name"
                          title={displaySheetName}
                        >
                          {displaySheetName}
                        </span>
                        {!!mappedTrainBaseLabel && (
                          <CustomTooltip
                            text={showTrainTooltip ? mappedTrainTooltip : ""}
                            placement="top"
                          >
                            <span className="upload-success-card__sheet-train-badge">
                              <span>{mappedTrainBaseLabel}</span>
                              {!!mappedTrainExtraLabel && (
                                <span className="upload-success-card__sheet-train-badge-count">
                                  {mappedTrainExtraLabel}
                                </span>
                              )}
                            </span>
                          </CustomTooltip>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
    </>
  );
};

export default UploadedFilesList;
